<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="title" label="标题">
              {{ formData.title || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.issueUserName">
            <el-form-item prop="issueUserName" label="当前处理人">
              {{ formData.issueUserName || "" }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>

          <el-col :span="24">
            <el-form-item prop="content" label="问题内容">
              {{ formData.content || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap" v-if="$attachmentFiles(formData.fileList).length > 0">
                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>
              </div>
              <div style="color:#999" v-else>暂无</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="办理记录">
              <el-timeline :reverse="true" placement="top" v-if="formData.feedbackList.length>0">
                <el-timeline-item placement="top" v-for="(item, index) of formData.feedbackList" :key="index"
                  :timestamp="item.ctime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24">
                        办理类型：
                        <!-- 1处理2分配3转办4审批 -->
                        <el-tag v-if="item.handleType == '1'">处理</el-tag>
                        <el-tag v-if="item.handleType == '2'">分配</el-tag>
                        <el-tag v-if="item.handleType == '3'">转办</el-tag>
                        <el-tag v-if="item.handleType == '4'">审批</el-tag>
                      </el-col>
                      <el-col :span="24">
                        办理人：{{ item.handlerName || '--' }} </el-col>

                        <el-col :span="24" v-if="item.handleType == '4'">
                          审批结果： <el-tag v-if="item.approvalResult == '1'">审批通过</el-tag>
                          <el-tag type="danger" v-if="item.approvalResult == '2'">审批驳回</el-tag></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        {{ item.handleType == '1' ? '处理内容' : item.handleType == '4' ? '审批意见' : '办理内容' }}:{{
                        item.feedbackContent
                        || '--' }}
                      </el-col>
                    </el-row>

                    <el-row v-if="item.fileList && $attachmentFiles(item.fileList).length > 0">
                      <el-col :span="24">
                        附件：
                        <div>
                          <div class="" v-for="(item2, index) of $attachmentFiles(item.fileList)" :key="index">
                            <a href="javascript:void(0)" @click="onDown(item2.filePrefix +item2.fileUrl)">{{
                              item2.fileName ||
                              "-" }}</a>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </el-card>

                </el-timeline-item>
              </el-timeline>
              <div style="color:#999" v-else>暂无</div>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <template v-if="formData.issueUserId == userId">
                <!-- 办理类型1处理2分配3转办4审批 -->
                <el-button type="primary" v-if="formData.status != '4'" @click="onClickBtn('3')">转办</el-button>
                <el-button type="primary" v-if="formData.status == '1'" @click="onClickBtn('2')">分配</el-button>
                <el-button type="primary" v-if="formData.status == '2'" @click="onClickBtn('1')">处理</el-button>
                <el-button type="primary" v-if="formData.status == '3'" @click="onClickBtn('4')">审核</el-button>
              </template>

            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

    </custom-actions>
    <PatrolProblemReportFeekbook v-if="showDlg" @successSave="loadData" :handleType='handleType'
      :issueId="formData.issueId" :status="formData.status" :showDlg.sync="showDlg"></PatrolProblemReportFeekbook>
  </div>
</template>

<script>
import PatrolProblemReportFeekbook from '@/views/patrolProblemReport/PatrolProblemReportFeekbook.vue'
export default {
  name: 'PatrolProblemReportDetail',
  components: {
    PatrolProblemReportFeekbook
  },
  data () {
    return {
      formData: {
        issueId: '',
        issueType: '',
        issueUserId: '',
        title: '',
        content: '',
        fileList: [],
        status: '',
        feedbackList: []
      },
      handleType: '',
      loading: false,
      showDlg: false

    }
  },
  created () {
    if (this.issueId) {
      this.loadData()
    }
  },
  computed: {
    issueId () {
      return this.$route.query.issueId
    },
    issueType () {
      return this.$route.query.issueType
    },
    userInfo () {
      return this.$store.state.user
    },
    userId () {
      console.log('this.userInfo.userId: ', this.userInfo.userId)
      return this.userInfo.userId
    },
    fileImgUrl() {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {
    onClickBtn (type) {
      this.handleType = type
      this.showDlg = true
    },
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.patrolProblemReport.selectPaIssueReportByIssueId, {
          params: { issueId: this.issueId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          res.feedbackList = res.feedbackList ? res.feedbackList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    onDown(url) {
      window.open(url, '_blank')
    },
    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          const url = this.$apis.patrolProblemReport.insertPaIssueReport

          this.$axios.post(url, { ...this.formData, issueType: this.issueType }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
